import {StubbornToolboxProperties} from "../../../../../../../../business/StubbornToolboxMapping";

export const toolbox: StubbornToolboxProperties = {
  name: 'image',
  label: 'Image',
  category: 'Layouts'
};
